import { useQuery } from "@tanstack/react-query";

import { ListEligibilityCategoriesFilterType } from "@/domain/eligibilityCategory";

import { EligibilityCategoriesApi } from "../api/eligibilityCategoriesApi";

export const EligibilityCategoriesQueryKeys = {
  all: ["eligibilityCategories"] as const,
  list: (filters?: ListEligibilityCategoriesFilterType) =>
    filters
      ? ([...EligibilityCategoriesQueryKeys.all, "list", { filters }] as const)
      : ([...EligibilityCategoriesQueryKeys.all, "list"] as const),
};

type ListEligibilityCategoriesParamsType = {
  filters: ListEligibilityCategoriesFilterType;
  enabled?: boolean;
};

export const useListEligibilityCategoriesQuery = ({
  filters,
  enabled,
}: ListEligibilityCategoriesParamsType) => {
  return useQuery({
    queryKey: EligibilityCategoriesQueryKeys.list(filters),
    queryFn: () => EligibilityCategoriesApi.listEligibilityCategories(filters),
    enabled,
  });
};
